import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { LanguageCode, EmailTranslationDto } from '../../shared/model';
import { DataService } from '../../data.service';

@Injectable({
  providedIn: 'root'
})
export class EmailTranslationsViewService {

  constructor(private dataService: DataService) { }

  getEmailTranslationsForLanguage(languageCode: LanguageCode): Observable<any> {
    return this.dataService.get('Translations/Email', { languageCode: languageCode });
  }

  saveEmailTranslations(emailTranslations: EmailTranslationDto[]): Observable<any> {
    return this.dataService.post('Translations/SaveEmails',  emailTranslations);
  }
}
